import {Customer} from "./customer";

export class PrivateCustomer extends Customer {
  toc: true;

  constructor(name: string, email: string, phone: number, toc: true) {
    super(email, phone, name, "Private");
    this.toc = toc;
  }
}
